import { useEffect, useMemo, useRef } from 'react';
export function useOptimizedRendering({ isPanning, isZooming, stateHash, renderFn, deps, }) {
    // Референсы для кэширования результата рендеринга
    const renderedResultRef = useRef(null);
    const isInteractingRef = useRef(false);
    const lastStateHashRef = useRef('');
    // Отслеживаем активное взаимодействие через ref ДО вызова useMemo
    const wasInteractingRef = useRef(isPanning || isZooming);
    isInteractingRef.current = isPanning || isZooming;
    // Мемоизированный рендеринг с оптимизацией для панорамирования/зума
    const renderedResult = useMemo(() => {
        // Во время активного панорамирования или зума НЕ пересчитываем - используем кэш
        // Это критично для предотвращения фриза в начале панорамирования/зума
        if (isInteractingRef.current &&
            renderedResultRef.current !== null &&
            lastStateHashRef.current === stateHash) {
            return renderedResultRef.current;
        }
        // Выполняем рендеринг
        const result = renderFn();
        // Сохраняем результат в ref для использования во время взаимодействия
        renderedResultRef.current = result;
        lastStateHashRef.current = stateHash;
        return result;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [renderFn, stateHash, ...deps]);
    // Отслеживаем завершение pan/zoom для принудительного обновления
    useEffect(() => {
        const wasInteracting = wasInteractingRef.current;
        const isInteracting = isPanning || isZooming;
        // Если pan/zoom только что завершился (было true, стало false)
        // Очищаем кэш, чтобы при следующем изменении зависимостей useMemo пересчитался
        if (wasInteracting && !isInteracting) {
            // Очищаем кэш результата, чтобы при следующем изменении зависимостей
            // useMemo пересчитался с актуальными данными
            lastStateHashRef.current = '';
        }
        wasInteractingRef.current = isInteracting;
    }, [isPanning, isZooming]);
    // Очистка кэша при размонтировании
    useEffect(() => {
        return () => {
            renderedResultRef.current = null;
            lastStateHashRef.current = '';
        };
    }, []);
    return renderedResult;
}
